module.exports = __webpack_public_path__ + "static/media/Intersection 22.b261aea6.png";